export default __webpack_public_path__ + "static/media/section-logo.27a41ece.png";